import { ChakraBaseProvider } from "@chakra-ui/react";
import { ReactNode } from "react";
import theme from "./theme";

type Props = {
  children: ReactNode;
};

export default function ChakraProvider({ children }: Props) {
  return <ChakraBaseProvider theme={theme}>{children}</ChakraBaseProvider>;
}
